// import axios from 'axios';

// const apiClient = axios.create({
//   baseURL: 'http://localhost:8080/api', // Change this to your API base URL
//   timeout: 10000, // Optional: Set a timeout
// });

// // Add request interceptors if needed (e.g., for adding tokens)
// apiClient.interceptors.request.use(config => {
//   // Example: Add authorization header if token exists
//   const token = localStorage.getItem('token'); // Adjust as needed
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// }, error => {
//   return Promise.reject(error);
// });

// // Define the API service
// const ApiCallService = {
//   get: async (url, params = {}) => {
//     try {
//       const response = await apiClient.get(url, { params });
//       return response.data;
//     } catch (error) {
//       console.error('GET Error:', error);
//       throw error; // Re-throw to handle in the calling function
//     }
//   },

//   post: async (url, data = {}) => {
//     try {
//       const response = await apiClient.post(url, data);
//       return response.data;
//     } catch (error) {
//       console.error('POST Error:', error);
//       throw error; // Re-throw to handle in the calling function
//     }
//   },

//   put: async (url, data = {}) => {
//     try {
//       const response = await apiClient.put(url, data);
//       return response.data;
//     } catch (error) {
//       console.error('PUT Error:', error);
//       throw error; // Re-throw to handle in the calling function
//     }
//   },

//   delete: async (url, config = {}) => {
//     try {
//       const response = await apiClient.delete(url, config);
//       return response.data;
//     } catch (error) {
//       console.error('DELETE Error:', error);
//       throw error; // Re-throw to handle in the calling function
//     }
//   },
// };

// export default ApiCallService;


import axios from 'axios';

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  // timeout: 10000,
});

// Function to check if the token is expired
const isTokenExpired = (token) => {
  if (!token) return true;
  const { exp } = JSON.parse(atob(token.split('.')[1]));
  return Date.now() >= exp * 1000;
};

// Add request interceptor to handle token refresh
apiClient.interceptors.request.use(async (config) => {
  let accessToken = localStorage.getItem('accessToken');

  // Check if token is expired
  if (isTokenExpired(accessToken)) {
    const refreshToken = localStorage.getItem('refreshToken');

    // Attempt to refresh the token
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/refresh-token`, {
        refreshToken,
      });

      // Store new access token
      accessToken = response.data.accessToken;
      localStorage.setItem('accessToken', accessToken);
      if (response.data.refreshToken) {
        localStorage.setItem('refreshToken', response.data.refreshToken);
      }
    } catch (error) {
      console.error('Failed to refresh token', error);
      // Optionally redirect to login or handle error
      return Promise.reject(error);
    }
  }

  // Add the access token to the headers
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor: handle 401/403 by attempting token refresh once
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Only retry on 401/403 and if not already retried
    if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return apiClient(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        isRefreshing = false;
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/refresh-token`, {
          refreshToken,
        });

        const newAccessToken = response.data.accessToken;
        localStorage.setItem('accessToken', newAccessToken);
        if (response.data.refreshToken) {
          localStorage.setItem('refreshToken', response.data.refreshToken);
        }

        apiClient.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);
        return apiClient(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        // Clear auth and redirect to login
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('userDetails');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);


// Define the API service
const ApiCallService = {
  get: async (url, params = {}) => {
    try {
      const response = await apiClient.get(url, { params });
      return response.data;
    } catch (error) {
      console.error('GET Error:', error);
      throw error;
    }
  },

  post: async (url, data = {}, config = {}) => {
    try {
      const response = await apiClient.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error('POST Error:', error);
      throw error;
    }
  },

  put: async (url, data = {}) => {
    try {
      
      const response = await apiClient.put(url, data);
      return response.data;
    } catch (error) {
      console.error('PUT Error:', error);
      throw error;
    }
  },
  patch: async (url, data = {}) => {
    try {

      const response = await apiClient.patch(url, data);
      return response.data;
    } catch (error) {
      console.error('PATCH Error:', error);
      throw error;
    }
  },

  delete: async (url, config = {}) => {
    try {
      const response = await apiClient.delete(url, config);
      return response.data;
    } catch (error) {
      console.error('DELETE Error:', error);
      throw error;
    }
  },
};

export default ApiCallService;
